export const CALENDAR_MODES = {
  preset: "Preset",
  custom: "Custom",
};
